module.exports = "<td ng-class=\"'display-as-' + column.displayAs\">\n  <div ng-if=\"!isValid\" class=\"json-cell-invalid\">{{ value }}</div>\n  <div ng-show=\"isValid\" class=\"json-cell-valid\"></div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/dynamic-table/json-cell/template.html
// module id = 385
// module chunks = 1